import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';
import { capitalizeWords } from '@zoocasa/node-kit/strings/capitalize';

import type { Breadcrumb } from 'components/breadcrumbs';

interface Props {
  breadcrumbs?: Breadcrumb[];
}

export default function ListingsGridBreadcrumbs({ breadcrumbs }: Props) {
  const breadcrumbArray: JSX.Element[] = [];

  if (breadcrumbs) {
    const numBreadcrumbs = breadcrumbs.length;
    breadcrumbs.forEach((element, index) => {
      const areaLabel = index > 1 ? capitalizeWords(element.name.toLowerCase()) : element.name.toUpperCase();;
      if (numBreadcrumbs - 1 == index) {
        breadcrumbArray.push(<Link underline="hover" color="inherit" key={index.toString() + 1} className={styles['active']} href={element.link}>
          {areaLabel}
        </Link>);
      } else {
        breadcrumbArray.push(<Link underline="hover" color="inherit" key={index.toString() + 1} href={element.link}>
          {areaLabel}
        </Link>);
      }
    });
  }

  return (
    <div data-testid={testIds.listingGridBreadcrumbs}>
      {breadcrumbArray.length > 0 && <Stack className={styles.breadcrumbs}>
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          {breadcrumbArray}
        </Breadcrumbs>
      </Stack>}
    </div>
  );
}
